import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import humanFormat from 'human-format';

// We use `pre` tag instead of `span` so that we can select the last
// MetricNumber element using `:last-of-type` pseudo selector.
const Container = styled.pre`
  font: ${props => props.theme.fontWeightBold} 15px/100% ${props => props.theme.fontFamilyBody};
  text-transform: uppercase;
  color: ${props => props.theme.secondaryColor};
  margin: 0;

  & > em {
    font-size: 26px;
    color: ${props => props.theme.bodyColor};
    font-style: normal;
    margin-right: ${props => (props.theme.isMobile ? 2 : 4)}px;
  }

  &:not(:last-of-type):after {
    content: "\u2022";
    margin: 0 ${props => (props.theme.isMobile ? 6 : 16)}px;
  }

  ${props => props.theme.isMobile && `
    font-size: 12px;
    line-height: 120%;

    & > em {
      font-size: 23px;
      line-height: 26px;
      letter-spacing: -0.025em;
    }
  `};
`;

export default function MetricNumber({ count, name }) {
  if (!count) {
    return null;
  }

  return (
    <Container>
      <em>{humanFormat(count, { decimals: 1, separator: '' })}</em>
      {count === 1 ? name : `${name}s`}
    </Container>
  );
}

MetricNumber.propTypes = {
  count: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};
